
const initialScale = [
  0,
  8,
  16,
  32,
  48,
  64,
  96
]

export default initialScale

